export function configureDebug($compileProvider, apexDebugInfoEnabled) {
    'ngInject';
    $compileProvider.debugInfoEnabled(apexDebugInfoEnabled);
}
